
import {
  defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import { Modal, Table } from 'ant-design-vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import Icone from '@/core/components/Icone.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import ServicoPCP from '@/servicos/PCP/ServicoPCP';
import { ISimulacaoProducao } from '@/models/Entidades/PCP/ISimulacaoProducao';
import SimulacaoProducaoModal from './SimulacaoProducaoModal.vue';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';

export default defineComponent({
  name: 'SimulacaoProducaoIndex',
  components: {
    Icone,
    MensagemSemDados,
    TituloPadrao,
    SimulacaoProducaoModal,
    ATable: Table,
  },
  setup() {
    const servicoPCP = new ServicoPCP();
    const {
      telaBase, apresentarMensagemSucesso,
    } = useTelaBase();

    const state = reactive({
      empresaSelecionada: 0,
      exibirModal: false,
      operacaoLancamento: {} as ITelaOperacao,
      simulacoes: [] as ISimulacaoProducao[],
      atualizarGrid: false,
    });

    const colunas = [
      {
        title: 'Descrição',
        dataIndex: 'descricao',
        key: 'descricao',
        ellipsis: true,
      },
      {
        title: 'Data',
        dataIndex: 'dataSimulacao',
        key: 'dataSimulacao',
        width: 120,
        align: 'center' as any,
      },
      {
        title: 'Observação',
        dataIndex: 'observacao',
        key: 'observacao',
        ellipsis: true,
      },
      {
        title: 'Ações',
        key: 'acoes',
        width: 100,
        align: 'center' as any,
      },
    ];

    async function buscarSimulacoes() {
      telaBase.carregando = true;
      state.simulacoes = await servicoPCP.obterListaSimulacao(state.empresaSelecionada);
      telaBase.carregando = false;
    }

    onBeforeMount(async () => {
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      await buscarSimulacoes();
    });

    function incluir() {
      state.operacaoLancamento = {
        tipoPermissaoDados: EPermissaoDados.Incluir,
        codigoRegistro: 0,
        empresaSelecionada: state.empresaSelecionada,
      } as ITelaOperacao;
      state.exibirModal = true;
    }

    function editar(codigoRegistro: number) {
      state.operacaoLancamento = {
        tipoPermissaoDados: EPermissaoDados.Alterar,
        codigoRegistro,
        empresaSelecionada: state.empresaSelecionada,
      } as ITelaOperacao;
      state.exibirModal = true;
    }

    async function excluir(codigo: number) {
      const retorno = await servicoPCP.excluirSimulacao(codigo);
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        await buscarSimulacoes();
      } else {
        Modal.warning({
          title: 'Não foi possível concluir a exclusão!',
          content: retorno.mensagem,
        });
      }
    }

    function confirmarExclusao(simulacao: ISimulacaoProducao) {
      Modal.confirm({
        title: 'Você confirma a exclusão da simulação?',
        content: `"${simulacao.descricao}"`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        centered: true,
        onOk: async () => { await excluir(simulacao.codigo); },
      });
    }

    function atualizarInformacoesTela() {
      state.atualizarGrid = true;
    }

    watch(() => state.exibirModal, (newValue) => {
      if (!newValue && state.atualizarGrid) {
        buscarSimulacoes();
        state.atualizarGrid = false;
      }
    });

    return {
      state,
      telaBase,
      colunas,
      incluir,
      editar,
      confirmarExclusao,
      atualizarInformacoesTela,
      UtilitarioData,
    };
  },
});
